import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { FullPolicy, MtaIneligibilityReason, PolicyStatus, Product } from '@acorn-portal/shared/src/services/api';
import { SchemeType } from '@acorn-portal/shared/src/services/interface/Shared';

export interface IFullPolicyState extends Omit<FullPolicy, 'scheme'> {
	scheme?: SchemeType;
}

export const INITIAL_STATE: IFullPolicyState = {
	policyToken: '',
	product: Product.PRIVATE_CAR,
	policyNumber: '',
	policyholder: {
		firstName: '',
		lastName: '',
		email: '',
		address: {
			line1: '',
			city: '',
			postcode: '',
		},
	},
	isAutoRenewalChangeBlocked: false,
	coverDetails: {
		coverType: '',
		premium: 0,
		deviceProvider: '',
		operatingArea: '',
		voluntaryExcess: 0,
		compulsoryExcess: 0,
		endorsements: [],
		driverExcesses: [],
		operator: '',
	},
	vehicleDetails: {
		registration: '',
		make: '',
		model: '',
		vehicleUse: '',
		annualMileage: 0,
		licencingAuthority: '',
	},
	productCode: '',
	address: {
		line1: '',
		city: '',
		postcode: '',
	},
	startDate: '1970-01-01',
	endDate: '1970-01-01',
	drivers: [],
	addOns: [],
	policyStatus: PolicyStatus.Expired,
	autoRenewal: false,
	renewalDetails: undefined,
	isShortTermPolicy: false,
	isMTAForSchemeDisallowed: false,
	isDirectDebitPaymentMethod: false,
	scheme: undefined,
	renewalDeclined: false,
	renewalDeclinedReason: '',
	nonFinancePolicy: false,
	isMileageBasedPolicy: false,
	isSubscriptionRestartAvailable: false,
	mtaEligibility: {
		isEligible: false,
		mtaIneligibilityReason: MtaIneligibilityReason.None,
	},
};

export const fullPolicySlice = createSlice({
	name: 'fullPolicy',
	initialState: INITIAL_STATE,
	reducers: {
		updateFullPolicyDetails: (state, action: PayloadAction<Partial<IFullPolicyState>>) => ({
			...state,
			...action.payload,
		}),
		setAutoRenewalFlag: (state, action: PayloadAction<boolean>) => ({
			...state,
			autoRenewal: action.payload,
		}),
		clearFullPolicyDetails: () => ({
			...INITIAL_STATE,
		}),
	},
});

export const { updateFullPolicyDetails, setAutoRenewalFlag, clearFullPolicyDetails } = fullPolicySlice.actions;
export default fullPolicySlice.reducer;
